import Model, { attr, belongsTo } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type RolloverOwner from 'teacher-ui-client/models/rollover-owner'
import type { RolloverStep } from 'teacher-ui-client/school-rollover/steps'
import type School from 'teacher-ui-client/models/school'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type DateTransform from 'teacher-ui-client/transforms/date'

export const STATUS_ACTIVE = 'active'
export const STATUS_COMPLETE = 'complete'

export default class SchoolRollover extends Model {
  @attr<StringTransform>('string') declare step: RolloverStep

  @attr<StringTransform>('string') declare status: string

  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @attr<DateTransform>('date') declare createdAt: Date

  @attr<DateTransform>('date') declare updatedAt: Date

  @belongsTo<RolloverOwner>('rollover-owner', { async: false, inverse: null }) declare rolloverOwner?: RolloverOwner

  @belongsTo<School>('school', { async: false, inverse: null }) declare school?: School

  // Properties

  get isActive() {
    return this.status === STATUS_ACTIVE
  }

  get teacherFullName() {
    return this.rolloverOwner?.fullName
  }

  [Type] = 'school-rollover' as const
}
